<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Dashboard
      </div>
    </template>

    <div class="d-flex">
      <v-btn-toggle
        v-model="chart"
        mandatory
        color="primary"
        background-color="white"
      >
        <v-btn small value="byService">Services</v-btn>
        <v-btn small value="byPro">Pros</v-btn>
        <v-btn small value="byUser">Users</v-btn>
      </v-btn-toggle>
     <div class="ml-auto">
       <FilterDialog v-model="history_days" />
     </div>

    </div>

    <ServiceChart
      v-if="chart==='byService'"
      :limit="bar_count"
      :days="history_days"
      @referralCount="count => referralCount = count"
    />
    <ProChart
      v-if="chart==='byPro'"
      :limit="bar_count"
      :days="history_days"
    />
    <UserChart
      v-if="chart==='byUser'"
      :limit="bar_count"
      :days="history_days"
    />
    <div class="text-center mt-1 grey--text text--darken-3" style="font-size: 12px">
      {{ referralCount }} Referrals in the last {{history_days}} day(s)
    </div>
    <!-- <Detail :pro_ids="pro_ids" :service_ids="service_ids" :user_ids="user_ids" :days="history_days"/> -->
  </ContentPage>
</template>

<script>
  import { ContentPage } from '@/components/pages'
  import FilterDialog from './FilterDialog'
  import { ProChart, ServiceChart, UserChart } from './charts'
  // import Detail from './Detail.vue'

  export default {
    name: 'HomeView',

    components: { ContentPage, FilterDialog, ProChart, ServiceChart, UserChart },

    data() {
      return {
        chart: 'byService',
        bar_count: 7,
        history_days: 30,
        referralCount: 0,
      }
    },
  }
</script>
